// Enterprise Sharing Utilities
import type { Warranty } from '../types/warranty';

/**
 * Share warranty via email
 */
export const shareViaEmail = (warranty: Warranty): void => {
  const subject = `Warranty Information: ${warranty.productName}`;
  const body = `
Product: ${warranty.productName}
Brand: ${warranty.brand}
Model: ${warranty.modelNumber}
Warranty Expires: ${new Date(warranty.warrantyExpiryDate).toLocaleDateString()}
Provider: ${warranty.warrantyProvider}
Status: ${warranty.status}
  `.trim();
  
  const emailUrl = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  window.open(emailUrl);
};

/**
 * Share warranty via WhatsApp
 */
export const shareViaWhatsApp = (warranty: Warranty): void => {
  const text = `Warranty Info: ${warranty.productName} (${warranty.brand}) expires ${new Date(warranty.warrantyExpiryDate).toLocaleDateString()}`;
  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(text)}`;
  window.open(whatsappUrl);
};

/**
 * Copy warranty information to clipboard
 */
export const copyToClipboard = async (warranty: Warranty): Promise<boolean> => {
  const text = `${warranty.productName} - ${warranty.brand} ${warranty.modelNumber} | Expires: ${new Date(warranty.warrantyExpiryDate).toLocaleDateString()}`;
  
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    return false;
  }
};

/**
 * Generate shareable warranty summary
 */
export const generateShareableSummary = (warranty: Warranty): string => {
  return `${warranty.productName} (${warranty.brand} ${warranty.modelNumber}) - Warranty expires ${new Date(warranty.warrantyExpiryDate).toLocaleDateString()}`;
};

/**
 * Share warranty with custom message
 */
export const shareWithCustomMessage = (warranty: Warranty, customMessage: string): void => {
  const summary = generateShareableSummary(warranty);
  const fullMessage = `${customMessage}\n\n${summary}`;
  
  if (navigator.share) {
    navigator.share({
      title: `Warranty: ${warranty.productName}`,
      text: fullMessage,
    }).catch(console.error);
  } else {
    copyToClipboard({
      ...warranty,
      productName: fullMessage
    });
  }
};
